import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { AppConfig } from '../app-config.loader';
import { Promemoria } from '../shared/models/promemoria.model';

@Injectable({
  providedIn: 'root'
})
export class PromemoriaService {
  private readonly apiBaseUrl: string = '';

  constructor(private readonly appConfig: AppConfig, private readonly http: HttpClient) {
    this.apiBaseUrl = `${appConfig.settings.apiRoot}/promemoria`;
  }


  loadPromemorie(): Observable<Promemoria[]> {
    return this.getPromemoria().pipe(
      map(list =>
        list.toSorted((a, b) => {
          const dataA = a.dataModifica ?? a.dataCreazione;
          const dataB = b.dataModifica ?? b.dataCreazione;
          return new Date(dataB).getTime() - new Date(dataA).getTime();
        })
      )
    );
  }

  savePromemoria(testo: string, mode: 'create' | 'edit', id?: number): Observable<any> {
    if (mode === 'edit' && id) {
      return this.updatePromemoria(id, testo);
    }
    return this.addPromemoria(testo);
  }

  getPromemoria(): Observable<Promemoria[]> {
    return this.http.get<Promemoria[]>(this.apiBaseUrl);
  }

  addPromemoria(testo: string): Observable<any> {
    return this.http.post<any>(this.apiBaseUrl, JSON.stringify(testo), {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  updatePromemoria(id: number, testo: string): Observable<any> {
    return this.http.put<any>(`${this.apiBaseUrl}/${id}`, JSON.stringify(testo), {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  deletePromemoria(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiBaseUrl}/${id}`);
  }
}